<template>
  <div class="layout-form">
    <error-reveal :error="error"></error-reveal>

    <div class="row expanded">
      <div class="small-8 columns">
        <label id="resolution">Felbontás:&nbsp;&nbsp;&nbsp;
          <input type="radio" v-model="resolution" name="pokemon" value="days" id="resolution-days" required><label for="resolution-days">napi</label>
          <input type="radio" v-model="resolution" name="pokemon" value="weeks" id="resolution-weeks"><label for="resolution-weeks">heti</label>
          <input type="radio" v-model="resolution" name="pokemon" value="months" id="resolution-months"><label for="resolution-months">havi</label>
        </label>
      </div>
      <div class="small-4 columns text-right">
        <label>Időszak: {{fmtFrom}} - {{fmtTo}}</label>
      </div>
    </div>

    <div class="row expanded">
      <div class="small-12 columns">
        <div id="chart" class="chart-container" style="clear: both;"></div>
      </div>
    </div>

    <div class="row expanded">
      <div class="small-6 columns">
        <table class="sum">
          <tr>
            <th style="width: 200px;text-align:center;">Metrika / Időszak</th>
            <th style="width: 130px;text-align:center;">Teljes időszak</th>
            <th style="width: 130px;text-align:center;">Kijelölés <br><span style="font-size: 80%;font-weight:normal;">{{fmtSelFrom}} - {{fmtSelTo}}</span> </th>
          </tr>
          <tr v-for="item in metrics">
            <th>{{item.name}}</th>
            <td>{{item.totalSum}}</td>
            <td>{{item.selectedSum}}</td>
          </tr>
        </table>
      </div>
      <div class="small-6 columns">
        <div id="heatmap" class="chart-container top-right" style="clear: both;"></div>
      </div>
    </div>


    <div class="row expanded bottom">
      <div class="small-4 columns">
        <button type="button" class="button primary trans-uppercase" @click="download">Letöltés</button>
        <button type="button" class="button secondary trans-uppercase" @click="back">Vissza</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
import 'moment-timezone'
import * as mutationTypes from '../../store/mutation-types'
import ErrorReveal from '../../errors/Reveal'
import insightsService from '../../services/insights'
import Highcharts from 'highcharts'
require('highcharts/modules/heatmap')(Highcharts)

export default {
  name: 'insights-display',
  components: {
    ErrorReveal
  },
  data () {
    return {
      insightsData: null,
      resolution: 'days',
      fmtFrom: null,
      fmtTo: null,
      error: null,
      loadParams: null,
      metrics: [
        {name: 'Bejegyzések száma', path: 'count', totalSum: 0, selectedSum: 0},
        {name: 'Consumption link clicks', path: 'post_clicks_by_type|lifetime.values.linkClicks', totalSum: 0, selectedSum: 0},
        {name: 'Consumption other clicks', path: 'post_clicks_by_type|lifetime.values.otherClicks', totalSum: 0, selectedSum: 0},
        {name: 'Consumption photo view', path: 'post_clicks_by_type|lifetime.values.photoView', totalSum: 0, selectedSum: 0},
        {name: 'Lifetime Post Total Reach', path: 'post_total_media_view_unique|lifetime.values.sum', totalSum: 0, selectedSum: 0},
        {name: 'Like', path: 'post_activity_by_action_type|lifetime.values.like', totalSum: 0, selectedSum: 0},
        {name: 'Share', path: 'post_activity_by_action_type|lifetime.values.share', totalSum: 0, selectedSum: 0},
        {name: 'Comment', path: 'post_activity_by_action_type|lifetime.values.comment', totalSum: 0, selectedSum: 0},
        {name: 'Video views', path: 'post_video_views|lifetime.values.sum', totalSum: 0, selectedSum: 0}
      ],
      resolutionParams: {
        days: {displayFormat: 'YYYY.MM.DD', dateFormat: 'YYYY-MM-DD', summarizer: 'daily', sumKeyFormat: 'YYYY-MM-DD', add: 1, unit: 'days'},
        weeks: {displayFormat: 'YYYY W. [hét]', dateFormat: 'YYYY [W]ww', summarizer: 'weekly', sumKeyFormat: 'YYYY [W]ww', add: 1, unit: 'weeks'},
        months: {displayFormat: 'YYYY.MM', dateFormat: 'YYYY-MM', summarizer: 'monthly', sumKeyFormat: 'YYYY-MM', add: 1, unit: 'months'}
      }
    }
  },
  watch: {
    resolution: 'onResolutionChanged'
  },
  created: function () {
    this.load(this.$route.query)
  },
  methods: {
    ...mapMutations([mutationTypes.BUSY_ON, mutationTypes.BUSY_OFF, mutationTypes.SET_HEADER_ACTIONS]),
    back () {
      this.$router.push({name: 'insights-query', query: this.loadParams})
    },
    load (params) {
      this.reset()
      this.loadParams = params
      this[mutationTypes.BUSY_ON]()
      insightsService.loadData(this.loadParams).then((data) => {
        this[mutationTypes.BUSY_OFF]()
        this.insightsData = data.data
        this.displayInsightsData(this.insightsData)
      })
      .catch((err) => {
        this[mutationTypes.BUSY_OFF]()
        this.error = err
      })
    },
    reset () {
    },
    download () {
      insightsService.downloadData(this.loadParams)
    },
    displayInsightsData (insightsData) {
      this.displayGeneralData(insightsData)
      this.displayTableData(insightsData)
      this.displayChart(insightsData)
      this.displayHeatmap(insightsData)
      this.displaySelectionData(insightsData)
      this.displaySelectionHeatmapData(insightsData)
    },
    displayGeneralData (insightsData) {
      this.fmtFrom = moment(insightsData.from).tz('Europe/Budapest').format('YYYY.MM.DD')
      this.fmtTo = moment(insightsData.to).tz('Europe/Budapest').format('YYYY.MM.DD')
    },
    displayTableData (insightsData) {
      _.forEach(this.metrics, (metrics, index) => {
        this.metrics[index].totalSum = _.get(insightsData.insights.total, metrics.path) || 0
      })
    },
    displaySelectionData (insightsData, selFrom, selTo) {
      var from = selFrom || moment(insightsData.from).tz('Europe/Budapest')
      var to = selTo || moment(insightsData.to).tz('Europe/Budapest')
      var current = moment(from).tz('Europe/Budapest')
      var resParams = this.resolutionParams[this.resolution]
      var summarizer = insightsData.insights[resParams.summarizer]
      var selSum = []
      var sumKey
      this.fmtSelFrom = from.format(resParams.displayFormat)
      this.fmtSelTo = to.format(resParams.displayFormat)

      _.forEach(this.metrics, (metrics, index) => {
        selSum.push(0)
      })

      while (current.format(resParams.dateFormat) <= to.format(resParams.dateFormat)) {
        sumKey = current.format(resParams.sumKeyFormat)
        if (summarizer.hasOwnProperty(sumKey)) {
          _.forEach(this.metrics, (metrics, index) => {
            selSum[index] += _.get(summarizer[sumKey], metrics.path) || 0
          })
        }
        current = current.add(resParams.add, resParams.unit)
      }

      _.forEach(this.metrics, (metrics, index) => {
        this.metrics[index].selectedSum = selSum[index]
      })
    },
    displaySelectionHeatmapData (insightsData, selFrom, selTo) {
      var from = selFrom || moment(insightsData.from).tz('Europe/Budapest')
      var to = selTo || moment(insightsData.to).tz('Europe/Budapest')
      var current = moment(from).tz('Europe/Budapest')
      var summarizer = insightsData.insights.postPerHour
      var sumKey
      var seriesData = []
      var dayIdx
      var hourIdx
      var count
      var perDay = []
      var perHour = []

      for (let d = 0; d < 7; d++) {
        perHour = []
        for (let h = 0; h < 24; h++) {
          perHour.push(0)
        }
        perDay.push(perHour)
      }

      this.fmtHeatmapSelFrom = from.format('YYYY-MM-DD 00')
      this.fmtHeatmapSelTo = to.format('YYYY-MM-DD 23')

      while (current.format('YYYY-MM-DD HH') <= this.fmtHeatmapSelTo) {
        sumKey = current.format('YYYY-MM-DD HH')
        dayIdx = _.toInteger(current.format('E')) - 1
        hourIdx = _.toInteger(current.format('H'))
        if (summarizer.hasOwnProperty(sumKey)) {
          count = summarizer[sumKey].count
          perDay[dayIdx][hourIdx] += count
        }
        current = current.add(1, 'hours')
      }

      _.each(perDay, (perHour, dayIdx) => {
        _.each(perHour, (count, hourIdx) => {
          seriesData.push([dayIdx, hourIdx, count])
        })
      })

      this.heatmapChart.series[0].setData(seriesData)
    },
    displayChart (insightsData) {
      var current = moment(insightsData.from).tz('Europe/Budapest')
      var to = moment(insightsData.to).tz('Europe/Budapest')
      var resParams = this.resolutionParams[this.resolution]
      var summarizer = insightsData.insights[resParams.summarizer]
      var onChartZoom = this.onChartZoom.bind(this)
      var sumKey
      var self = this

      this.chartCategories = []
      this.chartSeries = []

      _.forEach(this.metrics, (metrics) => {
        this.chartSeries.push({name: metrics.name, data: []})
      })

      while (current.format(resParams.dateFormat) <= to.format(resParams.dateFormat)) {
        this.chartCategories.push(current.format(resParams.displayFormat))
        sumKey = current.format(resParams.sumKeyFormat)
        if (summarizer.hasOwnProperty(sumKey)) {
          _.forEach(this.metrics, (metrics, index) => {
            this.chartSeries[index].data.push(_.get(summarizer[sumKey], metrics.path) || 0)
          })
        } else {
          _.forEach(this.metrics, (metrics, index) => {
            this.chartSeries[index].data.push(0)
          })
        }
        current = current.add(resParams.add, resParams.unit)
      }

      Highcharts.chart('chart', {
        chart: {
          events: {
            selection: onChartZoom
          },
          type: 'spline',
          zoomType: 'x'
        },
        title: {
          text: 'Insights adatok',
          x: -20
        },
        subtitle: {
        },
        xAxis: {
          categories: this.chartCategories
        },
        yAxis: {
          title: {
            text: 'Értékek'
          },
          plotLines: [{
            value: 0,
            width: 1,
            color: '#808080'
          }]
        },
        tooltip: {
          formatter: function () {
            var index = self.chartCategories.indexOf(this.x)
            var postCount = self.chartSeries[0].data[index]
            return '<b>' + this.series.name + '</b>: ' + Highcharts.numberFormat(this.y, 0, '.', ' ') +
              '<br><b>Bejegyzések száma</b>: ' + Highcharts.numberFormat(postCount, 0, '.', ' ')
          }
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle',
          borderWidth: 0
        },
        series: this.chartSeries
      })
    },
    displayHeatmap (insightsData) {
      var current = moment(insightsData.from).tz('Europe/Budapest')
      var to = moment(insightsData.to).tz('Europe/Budapest')
      var resParams = this.resolutionParams[this.resolution]
      var summarizer = insightsData.insights[resParams.summarizer]
      var sumKey
      var xAxis
      var yAxis

      this.chartCategories = []
      this.chartSeries = []

      _.forEach(this.metrics, (metrics) => {
        this.chartSeries.push({name: metrics.name, data: []})
      })

      while (current.format(resParams.dateFormat) <= to.format(resParams.dateFormat)) {
        this.chartCategories.push(current.format(resParams.displayFormat))
        sumKey = current.format(resParams.sumKeyFormat)
        if (summarizer.hasOwnProperty(sumKey)) {
          _.forEach(this.metrics, (metrics, index) => {
            this.chartSeries[index].data.push(_.get(summarizer[sumKey], metrics.path) || 0)
          })
        } else {
          _.forEach(this.metrics, (metrics, index) => {
            this.chartSeries[index].data.push(0)
          })
        }
        current = current.add(resParams.add, resParams.unit)
      }

      xAxis = ['Hétfő', 'Kedd', 'Szerda', 'Csütörtök', 'Péntek', 'Szombat', 'Vasárnap']
      yAxis = []
      for (var i = 0; i < 24; i++) {
        yAxis.push(i + '. óra')
      }

      this.heatmapChart = Highcharts.chart('heatmap', {
        chart: {
          type: 'heatmap',
          marginTop: 40,
          marginBottom: 80,
          plotBorderWidth: 1
        },
        title: {
          text: 'Posztok eloszlása óránként',
          x: -20
        },
        subtitle: {
        },
        xAxis: {
          categories: xAxis
        },
        yAxis: {
          categories: yAxis,
          title: null
        },
        colorAxis: {
          min: 0,
          minColor: '#FFFFFF',
          maxColor: Highcharts.getOptions().colors[0]
        },
        tooltip: {
          formatter: function () {
            return '<b>' + xAxis[this.point.x] + ' ' + this.point.y + ' óra</b>' +
              '<br><b>Bejegyzések száma</b>: ' + Highcharts.numberFormat(this.point.value, 0, '.', ' ')
          }
        },

        legend: {
          align: 'right',
          layout: 'vertical',
          margin: 0,
          verticalAlign: 'top',
          y: 25,
          symbolHeight: 475
        },
        series: [{
          name: 'Posztok száma óránként',
          borderWidth: 1,
          data: [],
          dataLabels: {
            enabled: true,
            color: '#000000'
          }
        }]
      })
    },
    onChartZoom (event) {
      if (event.xAxis) {
        var resParams = this.resolutionParams[this.resolution]
        var axis = event.xAxis[0]
        var zoomFrom = moment(this.insightsData.from).tz('Europe/Budapest').add(Math.round(axis.min), resParams.unit)
        var zoomTo = moment(this.insightsData.from).tz('Europe/Budapest').add(Math.round(axis.max), resParams.unit)
        this.displaySelectionData(this.insightsData, zoomFrom, zoomTo)
        this.displaySelectionHeatmapData(this.insightsData, zoomFrom, zoomTo)
      } else {
        this.displaySelectionData(this.insightsData)
        this.displaySelectionHeatmapData(this.insightsData)
      }
    },
    onResolutionChanged () {
      if (this.insightsData) {
        this.displayInsightsData(this.insightsData)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../../../sass/foundation-import';
  @import '../../../sass/layouts/form';

  .chart-container {
    border: 1px solid #999;
    &.top-right {
      margin-top: 20px;
      height: 600px;
    }
  }

  table.sum {
    border-collapse: collapse;
    margin: 20px 0;
    width: 100%;
    font-size: 80%;

    th, td {
      border: 1px solid #999;
      color: #888;
      padding: 10px;
    }

    th {
      text-align: left;
    }

    td {
      text-align: right;
    }
  }

</style>



// WEBPACK FOOTER //
// Display.vue?52737f71